import WelcomeCtrl from './welcome.controller';

export default {
  template: require('./welcome.html'),
  controller: WelcomeCtrl,
  windowClass: 'modal-welcome modal-md',
  windowTemplateUrl: '/modals/default/modal-container.html',

}



// WEBPACK FOOTER //
// ./project/modals/welcome/welcome.config.js